import { jsonToCSV } from "react-papaparse";

export const DocumentType = {
  CSV: "CSV",
  TEXT: "TEXT",
  PDF: "PDF",
  EXCEL: "XLS",
};

export const ReporterType = [{ type: "CSV" }, { type: "EXCEL" }];

export function getDocumentTitle(type, companyName) {
  const today = new Date();
  const currentTime = today.getHours() + "-" + today.getMinutes() + "-" + today.getSeconds();
  const currentDate = today.toJSON().slice(0, 10);
  return `${companyName}_PGW_${currentDate}_${currentTime}`;

  /*{
    [DocumentType.CSV]: `${companyName}_PGW`,
    [DocumentType.EXCEL]: `${companyName}_PGW`,
    [DocumentType.PDF]: `${companyName}_PGW`,
  }[type];*/
}

export function getDocumentLinkType(type) {
  return {
    [DocumentType.CSV]: "text/csv",
    [DocumentType.TEXT]: "text/plain",
    [DocumentType.EXCEL]: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // (OLD XLS) "application/vnd.ms-excel", //"application/ms-excel",
    [DocumentType.PDF]: "application/pdf",
  }[type];
}

export function getDocumentDownloadLinkAndDownload(data, type, companyName) {
  const title = getDocumentTitle(type, companyName);
  const documentType = getDocumentLinkType(type);

  const blob = new Blob([data], { type: documentType });

  console.log(blob)
  //Create Download URL and CLICK IT
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", `${title}${type === DocumentType.TEXT ? ".txt" : ""}`);
  link.click();
}

export function RemoveCommaDelimiterInData(data) {
  const clearedData = data.map((val) => {
    for (const key in val) {
      if (
        (typeof val[key] === "string" || val[key] instanceof String) &&
        (val[key]?.includes(",") || val[key]?.includes("\r") || val[key]?.includes("\n"))
      ) {
        val[key] = val[key]?.replace(/[\r]/g, "");
        val[key] = val[key]?.replace(",", "");
      }
    }
    return val;
  });
  return clearedData;
}

export function ParseDataToCSV(data) {
  //Convert Data to CSV
  const csvData = jsonToCSV(data);
  //console.log("STRING TO CSV ===========> ", { data, csvData });
  return csvData;
}

export function EncodeToBase64(stringData) {
  //ISSUE => https://github.com/WalletConnect/walletconnect-monorepo/issues/748
  //let cvsToBase64 = Buffer.from(JSON.stringify(csvData)).toString("base64");

  //https://stackoverflow.com/questions/9786508/javascript-atob-returning-string-contains-an-invalid-character
  const replacedData = encodeURIComponent(stringData).replace(/%([a-f0-9]{2})/gi, (m, $1) => String.fromCharCode(parseInt($1, 16)));

  //console.log("STRING TO CSV ===========> ", { replacedData, base64: window.btoa(replacedData) });
  return window.btoa(replacedData);
}
